<div class="c-plate" [style.background]="background">
  <span>PL</span>
  {{numberPlate}}
</div>
